export const CONSTANTS = {
  COLORS: {
    BLACK: "#011627",
    GREEN: "#49D49D",
    RED: "#FF0035",
    PURPLE: "#8B80F9",
    GREY:"#EEE5E5",
    BLUE:"#03F7EB",
    YELLOW:"#FCF300",
    ORANGE:"#FF9F1C",
    RED_TRANSPARENT: "#FF0035aa",
    PURPLE_TRANSPARENT: "#8B80F9aa",
  },
  CHART:{

  }
}


export default CONSTANTS;